<template>
  <div>
    <b-container fluid>
      <b-row class="call-us pull-center">
        <b-col sm="12" v-for="item in data" :key="item.title">
          {{ item.title }}
          <b-row>
            <b-col cols="12">
              <h3>
                <a :href="`tel:` + item.phoneNumberUrl">
                  Contact us:
                </a>
              </h3>
            </b-col>
            <b-col cols="12">
              <h1>
                <a :href="`tel:` + item.phoneNumberUrl">
                  {{ item.phoneNumber }}
                </a>
              </h1>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <!-- <div class="fab-wrapper" v-for="item in data" :key="item.title">
      <a :href="`https://wa.me/` + item.phoneNumberUrl" target="_blank">
        <label class="fab text-center" for="fabCheckbox">
          <b-icon
            icon="chat-dots"
            font-scale="3.5"
            variant="white"
            style="padding: 10px;"
          ></b-icon>
        </label>
      </a>
    </div> -->
  </div>
</template>

<script>
import { db } from "../firebase/db";
export default {
  data() {
    return {
      data: []
    };
  },
  firestore: {
    data: db.collection("callUs")
  }
};
</script>

<style lang="scss" scoped>
.call-us {
  padding: 20px 0;
  font-size: 20px;
  text-transform: uppercase;
  background: #293744;
  color: #ccc;
}
.call-us a {
  color: #efefef;
}
.call-us a:hover {
  text-decoration: none;
  color: #ffffff !important;
}
.fab-wrapper {
  position: fixed;
  bottom: 0.7rem;
  left: 4rem;
  z-index: 999;
}
.fab-checkbox {
  display: none;
}
.fab {
  position: absolute;
  bottom: -1rem;
  right: -1rem;
  width: 4rem;
  height: 4rem;
  background: #075e54;
  border-radius: 50%;
  box-shadow: 0px 5px 20px #087a6d;
  transition: all 0.3s ease;
  z-index: 1;
  border-bottom-right-radius: 6px;
  border: 1px solid #087a6d;
}

.fab:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
}
.fab-checkbox:checked ~ .fab:before {
  width: 90%;
  height: 90%;
  left: 5%;
  top: 5%;
  background-color: rgba(255, 255, 255, 0.2);
}
.fab:hover {
  background: #087a6d;
  box-shadow: 0px 5px 20px 5px #065a50;
}

.fab-checkbox:checked ~ .fab .fab-dots {
  height: 6px;
}

.fab .fab-dots-2 {
  transform: translateX(-50%) translateY(-50%) rotate(0deg);
}

.fab-checkbox:checked ~ .fab .fab-dots-1 {
  width: 32px;
  border-radius: 10px;
  left: 50%;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
}
.fab-checkbox:checked ~ .fab .fab-dots-3 {
  width: 32px;
  border-radius: 10px;
  right: 50%;
  transform: translateX(50%) translateY(-50%) rotate(-45deg);
}

@keyframes blink {
  50% {
    opacity: 0.25;
  }
}

.fab-checkbox:checked ~ .fab .fab-dots {
  animation: none;
}

.fab-wheel {
  position: absolute;
  bottom: 0;
  right: 0;
  border: 1px solid #af0000;
  width: 10rem;
  height: 10rem;
  transition: all 0.3s ease;
  transform-origin: bottom right;
  transform: scale(0);
}

.fab-checkbox:checked ~ .fab-wheel {
  transform: scale(1);
}
.fab-action {
  position: absolute;
  background: #0f1941;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: White;
  box-shadow: 0 0.1rem 1rem rgba(24, 66, 154, 0.82);
  transition: all 1s ease;

  opacity: 0;
}

.fab-checkbox:checked ~ .fab-wheel .fab-action {
  opacity: 1;
}

.fab-action:hover {
  background-color: #f16100;
}

.fab-wheel .fab-action-1 {
  right: -1rem;
  top: 0;
}

.fab-wheel .fab-action-2 {
  right: 3.4rem;
  top: 0.5rem;
}
.fab-wheel .fab-action-3 {
  left: 0.5rem;
  bottom: 3.4rem;
}
.fab-wheel .fab-action-4 {
  left: 0;
  bottom: -1rem;
}
</style>
